import { FC } from 'react';
import { AutoFillGenericModal, AutoFillGenericModalTexts, OnSaveAutoFill } from 'components/auto-fill-generic';
import { PRESIGNED_UPLOAD_USE_CASE } from 'constants/common';

const INVOICE_MODAL_TEXTS: AutoFillGenericModalTexts = {
  title: 'AI invoice autofill',
  description: 'Upload a document or add notes to fill your invoice',
  instructionsLabel: 'Need to add instructions ? (Optional)',
  instructionsPlaceholder:
    // eslint-disable-next-line quotes
    "Tell us anything important… e.g., 'use the PDF for prices', 'tax included'. You can also paste an image",
  loadingTitle: 'Filling your invoice',
  successMessage: 'Invoice details auto-filled successfully!'
};

interface InvoiceAutoFillModalProps {
  onSave: OnSaveAutoFill;
  isSaving: boolean;
  onError?: (error: Error) => void;
  isOpen: boolean;
  onClose: () => void;
}

const InvoiceAutoFillModal: FC<InvoiceAutoFillModalProps> = ({ onSave, isSaving, onError, isOpen, onClose }) => {
  return (
    <AutoFillGenericModal
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      isSaving={isSaving}
      texts={INVOICE_MODAL_TEXTS}
      enableFileUpload={true}
      uploadUseCase={PRESIGNED_UPLOAD_USE_CASE.INVOICE_AUTO_FILL}
      maxTextLength={1000}
      showTextAreaCharCount={true}
      onError={onError}
    />
  );
};

export default InvoiceAutoFillModal;
